// Mantine
import { Modal, Select, Button, NumberInput } from '@mantine/core'
import { notifications } from '@mantine/notifications'

// React
import { useState } from 'react'

// API
import { useAxiosApi } from '@/hooks/useAxiosApi'

// Icon
import { Check } from 'tabler-icons-react'

export default function ProductionOrderEditQuantity({
    opened,
    onClose,
    onChanged,
    ...productionOrder
}) {
    const [quantityValue, setQuantityValue] = useState(productionOrder.quantity)

    // API
    const { requestPatch } = useAxiosApi()

    const saveQuantity = async () => {
        await requestPatch(`/production-orders/${productionOrder.id}`, {
            quantity: quantityValue,
        })

        onChanged()
        onClose()

        notifications.show({
            title: 'Quantité modifiée',
            message: "La quantité cible de l'assemblage a été modifiée.",
            color: 'green',
            icon: <Check size={15} />,
        })
    }

    return (
        <>
            <Modal
                opened={opened}
                onClose={onClose}
                title="Modifier la quantité cible"
            >
                <div className="flex flex-col gap-3">
                    <NumberInput
                        min={1}
                        max={50000}
                        label="Quantité cible"
                        value={quantityValue}
                        onChange={setQuantityValue}
                    />

                    <Button onClick={saveQuantity}>
                        Enregistrer la quantité
                    </Button>
                </div>
            </Modal>
        </>
    )
}
